<div id="staff-tools" class="d-flex flex-column">
  <div class="d-flex flex-wrap align-items-center justify-content-end" style="margin-bottom: 3px">
    <div class="d-flex">
      <div class="d-flex" *ngIf="assignment.isLoaded && !classroom.showPrivateWhiteboard">
        <div class="wb-switcher d-flex">
          <button type="button" class="btn whiteboard-btn switcher-wb-a-btn mr-0" style="height: 26px"
                  title="Whiteboard"
                  (click)="classroom.selectedBoardTab !== ViewportTab.WHITEBOARD && switchViewPortTab(ViewportTab.WHITEBOARD)"
                  [class]="{'active': classroom.selectedBoardTab === ViewportTab.WHITEBOARD}">WB
          </button>

          <button type="button" class="btn whiteboard-btn switcher-wb-a-btn ml-0" style="height: 26px"
                  title="Assignment"
                  (click)="classroom.selectedBoardTab !== ViewportTab.ASSIGNMENT && switchViewPortTab(ViewportTab.ASSIGNMENT)"
                  [class]="{'active': classroom.selectedBoardTab === ViewportTab.ASSIGNMENT}">A
          </button>

          <button type="button" class="btn whiteboard-btn switcher-wb-a-btn ml-0" style="height: 26px"
                  title="Report"
                  (click)="classroom.selectedBoardTab !== ViewportTab.REPORT && switchViewPortTab(ViewportTab.REPORT)"
                  [class]="{'active': classroom.selectedBoardTab === ViewportTab.REPORT}">R
          </button>
        </div>
      </div>
    </div>

  </div>
</div>
